import type { SymbolPreviewItem } from '@/components/SymbolsPreview';
import type { Message } from '@/features/AIChat/context/utils';
import isHumanMessage from '@/features/AIChat/utils/isHumanMessage';
import type { SymbolKey } from '@/pages/Markets/MarketsComponents/types';

export const GX_REGEX = /GX\d{7}/g;

export function extractGxCodesFromMessage(msg: Message): string[] {
  if (isHumanMessage(msg)) return [];
  const raw: string[] = [];
  try {
    for (const part of msg.content) {
      if (part.kind === 'text') {
        const matches = part.text.match(GX_REGEX);
        if (matches) raw.push(...matches);
      } else if (part.kind === 'tool_result') {
        for (const row of part.rows) {
          if (row.code) {
            raw.push(row.code.trim());
          }
        }
      }
    }
  } catch (e) {
    console.error('Error extracting GX codes from message:', e);
  }
  const set = new Set(raw);
  return [...set];
}

export function toCatalogueItem(data: any): SymbolPreviewItem {
  if (!data) {
    return {
      symbol: { Code: '', PeriodType: '', Period: '', TimeRef: '' } as SymbolKey,
      label: '',
      metadata: { Currency: '', Units: '', Title: '' }
    };
  }
  return {
    symbol: {
      Code: data.Code,
      PeriodType: data.PeriodType,
      Period: data.Period || '1',
      TimeRef: data.TimeRef
    } as SymbolKey,
    label: '',
    metadata: {
      Alias: data.Alias,
      Currency: data.Currency,
      Units: data.Units,
      Title: data.Title
    }
  };
}

export function gxQueryKey(code: string) {
  return ['gxCodeAIChat', code] as const;
}
